module.exports = __webpack_public_path__ + "static/media/JamesPike.52fb42b6.jpg";